import * as $runtime from "../runtime.js";
import * as Partial from "../Partial/index.js";
const unsafeFromRight = dictShow => name => e => () => {
  if (e.tag === "Left") { return Partial._crashWith("Error decoding " + name + ": " + dictShow.show(e._1))(); }
  if (e.tag === "Right") { return e._1; }
  $runtime.fail();
};
const fromRightWith_ = def => v => {
  if (v.tag === "Left") { return def; }
  if (v.tag === "Right") { return v._1; }
  $runtime.fail();
};
const fromRightWith = f => v => {
  if (v.tag === "Left") { return f(v._1); }
  if (v.tag === "Right") { return v._1; }
  $runtime.fail();
};
const fromRightM = dictApplicative => f => v => {
  if (v.tag === "Left") { return f(v._1); }
  if (v.tag === "Right") { return dictApplicative.pure(v._1); }
  $runtime.fail();
};
export {fromRightM, fromRightWith, fromRightWith_, unsafeFromRight};
